module.exports = "/build/web/svg/social/small/instagram-blue.f1eef428169307c4ccdde28f5ee04fa1.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/small/instagram-blue.svg
// module id = 114
// module chunks = 24